import type { Document as RichTextDocument } from '@contentful/rich-text-types';
import Grid from '@mui/material/GridLegacy';
import classNames from 'classnames';
// biome-ignore lint/correctness/noUnusedImports: Automated migration to Biome
import React from 'react';
import type { Contentful } from '../../contentful/contentful-exports';
import RichText from './RichText';
import useStyles from './RichTextSection.styles';

export interface RichTextContent extends Contentful {
  fields: {
    title: string;
    textId?: string;
    richText: RichTextDocument;
    backgroundColor: 'offWhite' | 'mediumBlue' | 'blueGradient' | 'transparent';
  };
}

interface Props {
  content: RichTextContent;
  isEmbeddedLeadSection?: boolean;
  className?: string;
  innerClassName?: string;
}

/**
 * @deprecated V2 component
 */
export default function RichTextSection({
  content,
  isEmbeddedLeadSection = false,
  className,
  innerClassName,
}: Props) {
  const { classes } = useStyles();
  const { richText, backgroundColor } = content.fields;
  return (
    <Grid
      container
      className={classNames([
        classes.text,
        classes[`${backgroundColor}Background`],
        className,
      ])}
    >
      <Grid item xs={12} md={isEmbeddedLeadSection ? 12 : 8}>
        <RichText
          content={richText}
          className={innerClassName}
          title={content.fields?.title}
          textId={content.fields?.textId}
        />
      </Grid>
    </Grid>
  );
}
